import React, { useState } from "react";
import ProductModal from "../../../../components/ProductModal";
import { UseDisclosure } from "../../../../hooks/use-disclosure";
import styles from "./Row.module.sass";
import cn from "classnames";
import Icon from "../../../../components/Icon";
import Modal from "../../../../components/Modal";
import Confirm from "../../../../components/Confirm";
import TextInput from "../../../../components/TextInput";
import { UseApi } from "../../../../hooks/use-api";
import { UpdateNftTemplateHot } from "../../../../Services/lib/nfttemplates";
import { ToastEmitter } from "../../../../Services/assets/toast-emitter";
import Loader from "../../../../components/Loader";
import buttons from "./status.json";
import { GetStatus } from "./utils";
import Actions from "../../../../components/Actions";
import {
	CreateNftTemplate,
	DeleteProduct,
	MintProduct,
	UpdatHideShowTemplate,
} from "../../../../Services/lib/nft";
import { useUser } from "../../../../context";
import product from "../../../../i11/Product";
import TradeModel from "./TradeModel";
//
const getStatus = (type, Status) =>
	type === "Published" && Status !== "Minting" && Status !== "Minted";

const currencyConvert = (v) => {
	switch (v) {
		case "HBAR":
			return "ℏ";
		case "USD":
			return "$";
		case "GBP":
			return "£";
		default:
			return v;
	}
};

const Row = ({ item, open, set_edit, type, getNFTs_, closeC }) => {
	const { locale } = useUser();
	const start =
		item.startDate && !isNaN(new Date(item.startDate).getTime())
			? new Date(item.startDate)
			: "";
	const end =
		item.endDate && !isNaN(new Date(item.endDate).getTime())
			? new Date(item.endDate)
			: "";
	const Status =
		item.status === "DRAFT" ? "Draft" : GetStatus(item, start, end);
	const { isOpen, onClose, onOpen } = UseDisclosure();
	const {
		isOpen: confirmV,
		onClose: confirmC,
		onOpen: confirmO,
	} = UseDisclosure();

	const {
		isOpen: deleteV,
		onClose: deleteC,
		onOpen: deleteO,
	} = UseDisclosure();

	const {
		isOpen: isOpenTrade,
		onClose: onCloseTrade,
		onOpen: onOpenTrade,
	} = UseDisclosure();

	const { isOpen: hotV, onClose: hotC, onOpen: hotO } = UseDisclosure();
	const [isHot, setHot] = useState(item.hottest?.active === true);
	const [isHidden, setHidden] = useState(item.isLocked);

	const [prior, setPrior] = useState("1");

	const [{ isLoading }, priorChange] = UseApi({
		service: UpdateNftTemplateHot,
	});
	const [{ isLoading: LoadingUpload }, upload] = UseApi({
		service: CreateNftTemplate,
	});
	const [{ isLoading: LoadingHide }, hide] = UseApi({
		service: UpdatHideShowTemplate,
	});
	const [{ isLoading: LoadingDelete }, delete_] = UseApi({
		service: DeleteProduct,
	});
	const [{ isLoading: LoadingMint }, Mint] = UseApi({
		service: MintProduct,
	});

	const makeHot = async () => {
		const res = await priorChange({
			_id: item._id,
			hottest: {
				active: true,
				priority: prior,
			},
		});
		if (res) {
			setHot(true);
			ToastEmitter({
				type: "success",
				msg: "Successfully updated",
			});
			hotC();
		}
	};

	const Delete = async (immediate = false) => {
		if (immediate) {
			const res = await delete_(item._id);
			if (res) {
				ToastEmitter({
					type: "success",
					msg: "Product successfully deleted",
				});
				getNFTs_();
			}
			return;
		}
		if (item.status === "DRAFT") {
			const res = await delete_(item._id);
			if (res) {
				ToastEmitter({
					type: "success",
					msg: "Product successfully deleted",
				});
				getNFTs_();
			}
		} else {
			if (item.bids.length === 0) {
				const res = await upload({
					_id: item._id,
					status: "DRAFT",
				});
				if (res) {
					ToastEmitter({
						type: "success",
						msg: "Product successfully moved to Drafts",
					});
					// getNFTs_();
					closeC("Published");
				}
			} else {
				ToastEmitter({
					type: "info",
					msg: "Someone purchased or bid this item, So you can't delete or move it to darfts. You can edit it.",
				});
			}
		}
	};
	const HideController = async () => {
		const res = await hide({
			_id: item._id,
			isLocked: !isHidden,
		});
		if (res) {
			setHidden((p) => !p);
			ToastEmitter({
				type: "success",
				msg: "Product successfully updated",
			});
		}
	};

	const statusActions = {
		Closed: confirmO,
		Delete: deleteO,
	};

	const actionsDraft = [
		{
			title: product[locale].edit,
			icon: "edit",
			action: () => edit_({ isButton: true }),
		},
		{
			title: product[locale].desc_edit,
			icon: "link",
			href: `${process.env.REACT_APP_FRONTEND_URL}/template/${item._id}`,
			target: "_blank",
			action: undefined,
		},
		{
			isLoading: LoadingUpload || LoadingDelete,
			title: product[locale].delete,
			icon: "trash",
			action: () => deleteO(),
		},
	];

	const actionsPublished = [
		{
			isLoading: isLoading,
			title: isHot ? product[locale].remove_hot : product[locale].add_hot,
			icon: isHot ? "star-stroke" : "star-fill",
			action: () => {
				if (isHot) {
					disableHot();
				} else {
					hotO();
				}
			},
		},
		{
			isLoading: LoadingHide,
			title: isHidden ? product[locale].unhide : product[locale].hide,
			svgImage: isHidden ? "eye" : "hideEye",
			action: () => HideController(),
		},
		{
			title: product[locale][getStatus(type, Status) ? "edit" : "view"],
			icon: getStatus(type, Status) ? "edit" : "ticket",
			action: () => edit_({ isButton: true }),
		},
		{
			isLoading: LoadingUpload || LoadingDelete,
			title: product[locale].move_draft,
			icon: "trash",
			action: () => Delete(),
		},
	];
	const actionHoldInvoice = [
		{
			isLoading: isLoading,
			title: isHot ? product[locale].remove_hot : product[locale].add_hot,
			icon: isHot ? "star-stroke" : "star-fill",
			action: () => {
				if (isHot) {
					disableHot();
				} else {
					hotO();
				}
			},
		},
		{
			isLoading: LoadingHide,
			title: isHidden ? product[locale].unhide : product[locale].hide,
			svgImage: isHidden ? "eye" : "hideEye",
			action: () => HideController(),
		},
		{
			title: product[locale]["view"],
			icon: "ticket",
			action: () => edit_({ isButton: true }),
		},
	];

	const actionsTradeIn = actionsPublished;

	// const actionsTradeIn = [
	// 	...actionsPublished.slice(0, 3),
	// 	{
	// 		title: product[locale].trade_in,
	// 		icon: "ticket",
	// 		action: () => onOpenTrade(),
	// 	},
	// 	...actionsPublished.slice(3),
	// ];
	const actions =
		item.status === "HOLD_INVOICE"
			? actionHoldInvoice
			: item.status === "DRAFT"
			? actionsDraft
			: item.type !== "AUCTION_EDITION" && item.status === "OPEN"
			? actionsTradeIn
			: actionsPublished;
	const disableHot = async () => {
		const res = await priorChange({
			_id: item._id,
			hottest: {
				active: false,
				priority: prior,
			},
		});
		if (res) {
			setHot(false);
			ToastEmitter({
				type: "success",
				msg: "Successfully updated",
			});
		}
	};

	const onConfirm = async () => {
		const res_ = await Mint(item._id);
		if (res_) {
			getNFTs_();
			ToastEmitter({
				type: "success",
				msg: "Product successfully started minting",
			});
		}
	};

	const edit_ = ({ isButton = false }) => {
		if (type === "Drafts") set_edit(item);
		else if (getStatus(type, Status)) set_edit(item);
		else {
			if (isButton) {
				set_edit(item, true);
			} else open(item);
		}
	};

	const onDelete = () => {
		Delete(true);
	};
	const multiPrices = () => {
		if (item.multiPrices) {
			const prices = item.multiPrices?.map(
				(prr, i) =>
					`${prr.price} ${currencyConvert(prr.currency)}` +
					(i === item.multiPrices.length - 1 ? "" : " / ")
			);
			return prices.join("");
		}
		return `${item.price} ${item.currency}`;
	};

	return (
		<>
			<div className={styles.row}>
				<div className={styles.col}>
					<div onClick={edit_} className={styles.name}>
						<div className={styles.img}>
							<img src={item.image} alt={item.name} />
						</div>
						<div>
							<div>
								{isHot && <Icon name="star-fill" />}
								{isHidden && <Icon svgImage="hideEye" />}
							</div>
							<div>{item.name}</div>
						</div>
					</div>
				</div>
				<div className={styles.col}>{item.tokenType}</div>
				<div className={styles.col}>{multiPrices()}</div>
				<div className={styles.col}>
					<div>
						{start === ""
							? "- - - - - - -"
							: start.toLocaleDateString()}
					</div>
					<div>
						{start === ""
							? "- - - - - - -"
							: start.toLocaleTimeString()}
					</div>
				</div>
				<div className={styles.col}>
					<div>
						{end === ""
							? "- - - - - - -"
							: end.toLocaleDateString()}
					</div>
					<div>
						{end === ""
							? "- - - - - - -"
							: end.toLocaleTimeString()}
					</div>
				</div>
				<div className={styles.col}>
					{item.totalNFTs}/{item.bids.length}
				</div>
				<div
					className={cn(styles.col, {
						[styles.count]: ["Minted", "Published"].includes(type),
					})}
					onClick={() => {
						if (["Minted", "Published"].includes(type)) onOpen();
					}}
				>
					{item.type === "AUCTION_EDITION" ? "Auction" : "Sale"}
				</div>

				<div className={cn(styles.col)}>
					<div className={styles.actioncol}>
						<span>{buttons[Status].text}</span>
					</div>
				</div>
				<div className={styles.col}>{item.updatedAt}</div>

				<div className={cn(styles.col)}>
					<div className={styles.btns_}>
						{"Closed" === Status &&
							item.status !== "HOLD_INVOICE" && (
								<button
									onClick={statusActions[Status]}
									className={cn(buttons[Status].className, {
										disabled: LoadingDelete,
									})}
								>
									{LoadingDelete && <Loader />}
									{buttons[Status].btnTxt}
								</button>
							)}
						{["Delete", "Ongoing", "Upcoming"].includes(Status) &&
							item.bids.length === 0 && (
								<button
									onClick={statusActions["Delete"]}
									className={cn(buttons["Delete"].className, {
										disabled: LoadingDelete,
									})}
								>
									{LoadingDelete && <Loader />}
									{buttons["Delete"].btnTxt}
								</button>
							)}
						<Actions
							classActionsOption={styles.classActionsOption}
							classActionsHead={styles.actionsHead}
							items={actions}
						/>
					</div>
				</div>
			</div>
			<ProductModal
				visible={isOpen}
				onClose={onClose}
				data={item._id}
				nfts
				type={item.type}
			/>
			<Modal visible={confirmV} onClose={confirmC}>
				<Confirm
					isLoading={LoadingMint || isLoading}
					onCancel={confirmC}
					onConfirm={onConfirm}
					title={
						item.bids.length < item.totalNFTs
							? "This action will update product total count to sold count"
							: "Mint note"
					}
				/>
			</Modal>
			<Modal visible={deleteV} onClose={deleteC}>
				<Confirm
					isLoading={LoadingDelete || isLoading}
					onCancel={deleteC}
					onConfirm={onDelete}
					title={"This action will delete product permanently"}
				/>
			</Modal>
			<Modal visible={hotV} onClose={hotC}>
				<Confirm
					note="Enter priority"
					title="Make it HOT 🔥"
					onCancel={hotC}
					onConfirm={makeHot}
					isLoading={isLoading}
				>
					<TextInput
						className={styles.prior}
						label="Priority"
						name="priority"
						type="number"
						tooltip="If a product is assigned a priority, and the product with the lowest priority goes first of HOT items."
						value={prior}
						onChangeInput={setPrior}
					/>
				</Confirm>
			</Modal>

			{isOpenTrade && (
				<TradeModel
					isOpen={isOpenTrade}
					onClose={onCloseTrade}
					item={item}
				/>
			)}
		</>
	);
};

export default Row;
